import { render, staticRenderFns } from "./CreateNewViewDialog.vue?vue&type=template&id=964aa2bc&"
import script from "./CreateNewViewDialog.vue?vue&type=script&lang=js&"
export * from "./CreateNewViewDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewViewDialog.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports